import { APP_INITIALIZER, InjectionToken, NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatFormFieldDefaultOptions, MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MaterialModule, SharedModule } from './shared';
import { TranslocoRootModule } from './transloco-root.module';
import { MapViewService } from './shared/map/interfaces';
import { OpenLayersMapViewService } from './shared/map/open-layers-map-view.service';
import { LeafletMapViewService } from './shared/map/leaflet-map-view.service';
import { MatAutocompleteModule} from '@angular/material/autocomplete';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CustomHttpInterceptor } from './shared/http-interceptor/http-interceptor';
import { LicenseService } from './shared/license/license.service';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    MaterialModule,
    AppRoutingModule,
    HttpClientModule,
    TranslocoRootModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    FormsModule,
    MatCheckboxModule,
    MatInputModule,
    MatFormFieldModule,
  ],
  providers: [
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'fill' } as MatFormFieldDefaultOptions },
    // { provide: MapViewService, useClass: OpenLayersMapViewService }
    { provide: MapViewService, useClass: LeafletMapViewService },
    { provide: HTTP_INTERCEPTORS,useClass: CustomHttpInterceptor,multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: (licenseSvc: LicenseService) => () => licenseSvc.load(),
      deps: [LicenseService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

}
